import { useCallback } from 'preact/hooks';

type EntityType = 'product' | 'ingredient' | 'user';

interface EntityLinkProps {
  type: EntityType;
  id: string | number;
  label?: string;
  mono?: boolean;
}

function hashFor(type: EntityType, id: string | number): string {
  switch (type) {
    case 'product':
      return `catalog/products/${id}`;
    case 'ingredient':
      return `catalog/ingredients/${id}`;
    case 'user':
      return `catalog/users/${id}`;
  }
}

/**
 * Clickable inline entity link.
 * Navigates via hash to the entity detail page.
 */
export function EntityLink({ type, id, label, mono }: EntityLinkProps) {
  const handleClick = useCallback((e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.hash = hashFor(type, id);
  }, [type, id]);

  const displayLabel = label ?? String(id);

  return (
    <a
      href={`#${hashFor(type, id)}`}
      class={`entity-link entity-link-${type}${mono ? ' entity-link-mono' : ''}`}
      onClick={handleClick}
      title={`View ${type}: ${displayLabel}`}
    >
      {displayLabel}
    </a>
  );
}
